import { Injectable } from '@angular/core';

export type PngExportOptions = {
  readonly filename?: string;
  readonly quality?: number;
  readonly addTimestamp?: boolean;
};

@Injectable({
  providedIn: 'root',
})
export class ExportPngService {
  exportCanvas(canvas: HTMLCanvasElement, options: PngExportOptions = {}): void {
    const { filename = 'sequence-diagram', quality = 1.0, addTimestamp = true } = options;

    const finalFilename = this._generateFilename(filename, addTimestamp);
    const dataUrl = canvas.toDataURL('image/png', quality);

    this._triggerDownload(dataUrl, finalFilename);
  }

  private _generateFilename(basename: string, addTimestamp: boolean): string {
    const cleanName = basename
      .replace(/[<>:"/\\|?*]/g, '_')
      .replace(/\s+/g, '-')
      .toLowerCase()
      .substring(0, 50);

    if (!addTimestamp) return `${cleanName}.png`;

    const timestamp = new Date().toISOString()
.slice(0, 10);

    return `${cleanName}-${timestamp}.png`;
  }

  private _triggerDownload(dataUrl: string, filename: string): void {
    const link = document.createElement('a');
    link.download = filename;
    link.href = dataUrl;

    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }
}
